export const UNIT_TYPES = [
  { value: 'unidade', label: 'Venda por unidade' },
  { value: 'litro', label: 'Venda fracionada litro (ml)' },
  { value: 'kilo', label: 'Venda fracionada kilo (gramas)' },
]
